import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../../css/success_page.css"

const SubscriptionSuccess: React.FC = () => {
    useEffect(() => {
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-green-50 px-6">
            <div className="bg-white shadow-lg rounded-lg p-10 max-w-lg text-center animate-fade-in-up">
                <div className="flex justify-center mb-6">
                    <div className="bg-green-100 rounded-full p-4 animate-pulse">
                        <span className="text-green-600 text-4xl">✅</span>
                    </div>
                </div>
                <h1 className="text-3xl font-bold text-green-700 mb-4">Subscription Successful!</h1>
                <p className="text-gray-600 mb-6">
                    🎉 Thank you for subscribing! Your account has been upgraded and you now have access to premium features.
                </p>
                <Link to="/subscription">
                    <button className="bg-green-600 hover:bg-green-700 text-white font-medium px-6 py-2 rounded-lg transition">
                        Go Back to Plans
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default SubscriptionSuccess;
